import Api, { params } from '../modules/Api.js';

import { IS_LOADING, ISNT_LOADING } from './isLoading';
import { SET_ERROR, RESET_ERROR } from './error';

export const GET_RULES_REQUESTED = 'rules/GET_RULES_REQUESTED';
export const GET_RULES_SUCCESSFUL = 'rules/GET_RULES_SUCCESSFUL';
export const GET_RULES_FAILED = 'rules/GET_RULES_FAILED';

export const RULES_DOWNLOAD_REQUESTED = 'rules/RULES_DOWNLOAD_REQUESTED';
export const RULES_DOWNLOAD_SUCCESSFUL = 'rules/RULES_DOWNLOAD_SUCCESSFUL';
export const RULES_DOWNLOAD_FAILED = 'rules/RULES_DOWNLOAD_FAILED';

const initialState = {
  rules: [],
};

export default function Rules(state = initialState, action) {
  switch (action.type) {
    case GET_RULES_SUCCESSFUL:
      return {
        ...state,
        rules: action.rules,
      };
    case GET_RULES_FAILED:
      return initialState;
    case RULES_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        download: { file: action.download.file, name: action.download.name },
      };
    case RULES_DOWNLOAD_FAILED:
      return state;
    default:
      return state;
  }
}

export const getRules = () => async (dispatch) => {
  dispatch({ type: RESET_ERROR });
  dispatch({ type: IS_LOADING });
  dispatch({ type: GET_RULES_REQUESTED });

  return Api('/rules', { params: params })
    .then((res) => {
      dispatch({
        type: GET_RULES_SUCCESSFUL,
        rules: res.data,
      });
      dispatch({ type: ISNT_LOADING });
    })
    .catch((err) => {
      dispatch({ type: GET_RULES_FAILED });
      if (err?.response?.status !== 401) {
        dispatch({
          type: SET_ERROR,
          value: err,
        });
      }
      dispatch({ type: ISNT_LOADING });
    });
};
